// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2waFG","colBig":"styles_colBig__2KwZc","colSmall":"styles_colSmall__1jwkr","shopifyNameWrapper":"styles_shopifyNameWrapper__bJEGb"};